
      import PaperManual from './paper-manual.vue'
      import type { App, Plugin } from 'vue'

      export const PaperManualPlugin: Plugin = {
        install(app: App) {
          app.component('PaperManual', PaperManual)
        },
      }
      export { PaperManual }
      